import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const closeDrawer = () => {
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first then scroll
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: sectionId } });
      closeDrawer();
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    closeDrawer();
  };

  const drawer = (
    <Box sx={{ width: 250, pt: 2 }}>
      <List>
        <ListItem>
          <Button
            onClick={() => scrollToSection("about")}
            fullWidth
            className="font-weight-400"
            sx={{
              color: "#333",
              textTransform: "none",
              fontSize: "16px",
              justifyContent: "flex-start",
              "&:hover": {
                backgroundColor: "transparent",
                color: "#87EA5C",
              },
            }}
          >
            About
          </Button>
        </ListItem>
        <ListItem>
          <Button
            component={Link}
            to="/generate-referral-code"
            onClick={closeDrawer}
            fullWidth
            className="font-weight-400"
            sx={{
              color: "#333",
              textTransform: "none",
              fontSize: "16px",
              justifyContent: "flex-start",
              "&:hover": {
                backgroundColor: "transparent",
                color: "#87EA5C",
              },
            }}
          >
            Get Your Referral Code
          </Button>
        </ListItem>
        <ListItem>
          <Button
            onClick={() => scrollToSection("process")}
            fullWidth
            className="font-weight-400"
            sx={{
              color: "#333",
              textTransform: "none",
              fontSize: "16px",
              justifyContent: "flex-start",
              "&:hover": {
                backgroundColor: "transparent",
                color: "#87EA5C",
              },
            }}
          >
            Procedure
          </Button>
        </ListItem>
        <ListItem>
          <Button
            component={Link}
            to="/register"
            onClick={closeDrawer}
            fullWidth
            className="font-weight-700"
            sx={{
              backgroundColor: "#87EA5C",
              color: "#000",
              textTransform: "none",
              fontSize: "16px",
              justifyContent: "center",
              borderRadius: "22px",
              py: 1,
              mt: 1,
              "&:hover": {
                backgroundColor: "#75d84a",
              },
            }}
          >
            Register Now →
          </Button>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#ffffff",
        boxShadow: "none",
        borderBottom: "1px solid #f0f0f0",
        position: { xs: "sticky", md: "static" },
        top: { xs: 0, md: "auto" },
        zIndex: { xs: 1100, md: "auto" },
      }}
    >
      <Toolbar
        sx={{ justifyContent: "space-between", py: 0.5, minHeight: "48px" }}
      >
        {/* Logo */}
        <Box
          component={Link}
          to="/"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 0.25, md: 0.75 },
            textDecoration: "none",
          }}
        >
          <Box
            component="img"
            src="/assets/logonew.png"
            alt="Yuva Changemakers Logo"
            sx={{
              width: { xs: "152.6px", md: "249px" },
              height: { xs: "43.09px", md: "64px" },
            }}
          />
          <Box
            sx={{
              width: "32px",
              height: "0px",
              borderTop: "1.5px solid #000000",
              opacity: 0.2,
              transform: "rotate(90deg)",
              alignSelf: "center",
            }}
          />
          <Box
            component="img"
            src="/assets/logotwo.png"
            alt="Partner Logo"
            sx={{
              width: { xs: "110px", md: "193.039px" },
              height: { xs: "32.48px", md: "57px" },
            }}
          />
        </Box>

        {/* Desktop Navigation Items */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 3,
            alignItems: "center",
          }}
        >
          <Button
            onClick={() => scrollToSection("about")}
            className="font-weight-400"
            sx={{
              color: "#333",
              textTransform: "none",
              fontSize: "18px",
              "&:hover": {
                backgroundColor: "transparent",
                color: "#87EA5C",
              },
            }}
          >
            About
          </Button>

          <Button
            onClick={() => scrollToSection("process")}
            className="font-weight-400"
            sx={{
              color: "#333",
              textTransform: "none",
              fontSize: "18px",
              "&:hover": {
                backgroundColor: "transparent",
                color: "#87EA5C",
              },
            }}
          >
            Procedure
          </Button>
          <Button
            component={Link}
            to="/generate-referral-code"
            className="font-weight-400"
            sx={{
              color: "#333",
              textTransform: "none",
              fontSize: "18px",
              "&:hover": {
                backgroundColor: "transparent",
                color: "#87EA5C",
              },
            }}
          >
            Get Your Referral Code
          </Button>
          <Button
            component={Link}
            to="/register"
            className="font-weight-700"
            sx={{
              backgroundColor: "#87EA5C",
              color: "#000",
              textTransform: "none",
              fontSize: "18px",
              px: 3,
              py: 1,
              borderRadius: "22px",
              "&:hover": {
                backgroundColor: "#75d84a",
              },
            }}
          >
            Register Now →
          </Button>
        </Box>

        {/* Mobile Menu Icon */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ display: { md: "none" }, color: "#333" }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
